export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7701.1e81c01e.jpg";